import type { ReactNode } from 'react'
import {
  Card,
  CardContent,
  CardHeader,
  CardHeaderActions,
  CardTitle,
} from '@/components/Card'

import { IconButton } from '@/components/IconButton'
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
} from '@/components/EmptyState'
import { Button } from '@/components/Button'
import styles from './AmendmentsCard.module.css'
import { Tooltip } from '@/components/Tooltip'

export interface AmendmentsCardProps {
  canAddAmendment: boolean
  onAddAmendment: () => unknown
  isTableVisible: boolean
  table?: ReactNode
}

export function AmendmentsCard({
  canAddAmendment,
  onAddAmendment,
  isTableVisible,
  table,
}: AmendmentsCardProps) {
  return (
    <div className={styles.root}>
      <Card>
        <CardHeader>
          <CardTitle>Amendments</CardTitle>
          <CardHeaderActions>
            {canAddAmendment && (
              <Tooltip content="Add an amendment">
                <IconButton
                  name="add"
                  label="Add amendment"
                  onPress={onAddAmendment}
                  testId="add-amendment-button"
                />
              </Tooltip>
            )}
          </CardHeaderActions>
        </CardHeader>
        <CardContent scroll compact>
          {isTableVisible ? (
            table
          ) : (
            <div className={styles.emptyState}>
              <EmptyState size="card">
                <EmptyStateDescription>
                  Whether the client is requesting a refund, additional or
                  reduced services, or the Pro is requesting additional
                  earnings, you can make amendments to the job here.
                </EmptyStateDescription>
                {canAddAmendment && (
                  <EmptyStateActions>
                    <Button
                      label="Add an amendment"
                      onPress={onAddAmendment}
                      testId="add-amendment-button"
                      variant="text"
                    />
                  </EmptyStateActions>
                )}
              </EmptyState>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
